import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SalesReleaseDetail_Create, SalesReleaseDetail_Delete, SalesReleaseDetail_ReadAll, SalesReleaseDetail_ReadById, SalesReleaseDetail_ReadByItemId, SalesReleaseDetail_ReadByReleaseId, SalesReleaseDetail_ReadByReleaseIdForImport, SalesReleaseDetail_Update, SalesReleaseDetail_CreateBulk, SalesReleaseDetail_UpsertBulk } from "src/app/GlobalVariables";
import { SalesReleaseDetailCreateRequestDTO, SalesReleaseDetailDeleteRequestDTO, SalesReleaseDetailDTO, SalesReleaseDetailList, SalesReleaseDetailReadByIdRequestDTO, SalesReleaseDetailReadByItemIdRequestDTO, SalesReleaseDetailReadByReleaseIdForImportRequestDTO, SalesReleaseDetailReadByReleaseIdRequestDTO, SalesReleaseDetailUpdateRequestDTO, SalesReleaseDetailCreateBulkRequestDTO, SalesReleaseDetailUpsertBulkRequestDTO } from "./sales-release-detail.interface";

@Injectable({
    providedIn: 'root'
})

export class SalesReleaseDetailService {
    constructor() { }

    http = inject(HttpClient);

    SalesReleaseDetail_Create(data: SalesReleaseDetailCreateRequestDTO): Observable<SalesReleaseDetailDTO> {
        return this.http.post<SalesReleaseDetailDTO>(SalesReleaseDetail_Create, data);
    }

    SalesReleaseDetail_Update(data: SalesReleaseDetailUpdateRequestDTO): Observable<SalesReleaseDetailDTO> {
        return this.http.post<SalesReleaseDetailDTO>(SalesReleaseDetail_Update, data);
    }

    SalesReleaseDetail_Delete(data: SalesReleaseDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesReleaseDetail_Delete, data);
    }

    SalesReleaseDetail_ReadAll(): Observable<SalesReleaseDetailList> {
        return this.http.get<SalesReleaseDetailList>(SalesReleaseDetail_ReadAll);
    }

    SalesReleaseDetail_ReadById(data: SalesReleaseDetailReadByIdRequestDTO): Observable<SalesReleaseDetailList> {
        return this.http.post<SalesReleaseDetailList>(SalesReleaseDetail_ReadById, data);
    }

    SalesReleaseDetail_ReadByItemId(data: SalesReleaseDetailReadByItemIdRequestDTO): Observable<SalesReleaseDetailList> {
        return this.http.post<SalesReleaseDetailList>(SalesReleaseDetail_ReadByItemId, data);
    }

    SalesReleaseDetail_ReadByReleaseId(data: SalesReleaseDetailReadByReleaseIdRequestDTO): Observable<SalesReleaseDetailList> {
        return this.http.post<SalesReleaseDetailList>(SalesReleaseDetail_ReadByReleaseId, data);
    }

    SalesReleaseDetail_ReadByReleaseIdForImport(data: SalesReleaseDetailReadByReleaseIdForImportRequestDTO): Observable<SalesReleaseDetailList> {
        return this.http.post<SalesReleaseDetailList>(SalesReleaseDetail_ReadByReleaseIdForImport, data);
    }

    SalesReleaseDetail_CreateBulk(data: SalesReleaseDetailCreateBulkRequestDTO): Observable<void> {
        return this.http.post<void>(SalesReleaseDetail_CreateBulk, data);
    }

    SalesReleaseDetail_UpsertBulk(data: SalesReleaseDetailUpsertBulkRequestDTO): Observable<SalesReleaseDetailList> {
        return this.http.post<SalesReleaseDetailList>(SalesReleaseDetail_UpsertBulk, data);
    }
}